import {Subject} from 'rxjs';

export class BatchCoordinator {
  private level: number = 0;
  private batchEnd$: Subject<void> = new Subject();

  runInBatch<R>(callback: () => R): R {
    // Increment the batch level.
    // We need this over a boolean to track this for nested batches.
    this.level += 1;

    try {
      return callback();
    } finally {
      // Decrement batch level.
      this.level -= 1;
    }
  }

  subscribeToBatchEnd(handler: () => void): () => void {
    const subscription = this.batchEnd$.subscribe(handler);
    return () => subscription.unsubscribe();
  }

  maybeFinalizeBatch() {
    // If we're in the middle of a nested batch, don't finalize.
    if (this.isBatching()) {
      return;
    }

    // Otherwise, emit on the batchEnd$ observable.
    this.batchEnd$.next();
  }

  isBatching() {
    return this.level !== 0;
  }

  reset() {
    this.level = 0;
  }
}
